import { Button, Layout, type LayoutProps } from 'antd';

import styled from '@emotion/styled';

export const Header = styled(Layout.Header)<LayoutProps>`
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const UserName = styled.span`
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
`;

export const CompanyName = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.white};
`;

// A real button, not a styled anchor: this ends the session, and an <a> with no href is neither
// focusable nor announced as a control. The `&&` bumps specificity over antd's own .ui-btn colours,
// which would otherwise put a dark glyph and a light hover fill on this dark header.
export const Logout = styled(Button)`
  margin-left: 80px;

  && {
    color: ${({ theme }) => theme.colors.white};
  }

  &&:hover {
    color: ${({ theme }) => theme.colors.white};
    background: transparent;
    opacity: 0.75;
  }
`;

export const Text = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.textGrey};
`;

export const DebugText = styled.span`
  font-size: 10px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.textDisabled};
`;
